import { Record } from "immutable";
import { Details } from "./details";

const defaults = {
    _id: undefined,
    details: undefined,
    display: false,
    display_to_buyers: false,
    no_default: false,
    filterable: false,
    key: "",
    name: "",
    required: false,
    searchable: false,
    unique: false,
};

export class Field extends Record(defaults) {
    declare _id: string;
    declare key: string;
    declare name: string;
    declare required: boolean;
    declare searchable: boolean;
    declare filterable: boolean;
    declare display_to_buyers: boolean;
    declare display: boolean;
    declare unique: boolean;
    declare details: Details;

    constructor(args) {
        super({
            ...args,
            details: args.details && new Details(args.details),
        });
    }
}
